import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M2 7.2h3v-3H2zm1-2h1v1H3zm10.5-3.7V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5h-4V1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.5H0v13h16v-13zm1.5 12H1v-11h1.5V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5h4V3c0 .3.2.5.5.5s.5-.2.5-.5v-.5H15zM2 11.8h3v-3H2zm1-2h1v1H3zm8-2.6h3v-3h-3zm1-2h1v1h-1zm-5.5 2h3v-3h-3zm1-2h1v1h-1zm-1 6.6h3v-3h-3zm1-2h1v1h-1zm3.5 2h3v-3h-3zm1-2h1v1h-1z" />
  </svg>
);
const SvgCalendarNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="calendar-next" {...props} />;
export default SvgCalendarNext;
